import {
  cloneDeep,
  // inRange,
  // mapValues,
  orderBy,
  shuffle,
} from 'lodash';
import {
  // FileType,
  // ImageVersion,
  I18nLocale,
  // UserId,
} from '../../models/Base';
import {
  // FileData,
  GameControllerI18n,
  GameControllerInfo,
  GameInfo,
  OpponentsRecords,
} from '../../models/GameControllerStore';
import {
  // GameChoiceType,
  GameData,
  GameJson,
  GameType,
  GameTypes,
  GameVariant,
  I18nGameData,
  TextOrderingUnitType,
} from '../../models/GameStore';
import {
  GameRecord,
  GameRecordJson,
  // RevisionSchedule,
  // RevisionScheduleJson,
} from '../../models/RecordStore';
import { Profile, ProfileJson } from '../../models/UserStore';
import { RequiredPick } from '../../models/Utils';
import { useSpaceStore } from '../../stores/SpaceStore';
import { getFromI18n } from '../../utils/i18n';
import {
  getStarsByScore,
  revisionPhaseToMemoryIndex,
} from '../../utils/record';
import { getCharacterCount } from '../../utils/string';
import { ScopeType } from '../../utils/url';
import { getGameScope, isSpeaking, mergeSound } from './utils';

const INFINITY_TIME = false;

const isGameType = <G extends GameType>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  g: GameControllerInfo<any>,
  type: G,
): g is GameControllerInfo<G> => {
  return g.gameType === type;
};

export const applyLocaleAndVariant = <G extends GameType>(
  { i18nGameData, ...rest }: GameInfo<G> & Pick<GameJson, 'i18nGameData'>,
  _locale: I18nLocale | undefined,
  soundLocale: I18nLocale | undefined,
  variant = 0,
): GameControllerInfo<G> => {
  const isSpeakingGame = isSpeaking(); // isSpeaking(rest.gameType);
  const locale = isSpeakingGame ? i18nGameData.defaultLocale : _locale;

  const { title, description, translatedBy, variants } = getFromI18n(
    i18nGameData as I18nGameData<GameTypes[G]['variant']>,
    locale,
  );

  const othersLocale = (
    Object.entries(i18nGameData.resources) as [I18nLocale, GameData][]
  ).filter(([k]) => k !== locale);

  const translateGameData = othersLocale.map<GameControllerI18n<G>>(
    ([k, value]) => ({
      ...(value.variants[variant % value.variants.length] as GameVariant),
      title,
      description,
      translatedBy,
      locale: k,
    }),
  );

  const v = cloneDeep(
    variants[variant % variants.length] as GameTypes[G]['variant'],
  );
  if (soundLocale && !isSpeakingGame) {
    const soundVariants = getFromI18n(
      i18nGameData as I18nGameData<GameTypes[G]['variant']>,
      soundLocale,
    ).variants;
    const sv = soundVariants[variant % soundVariants.length];
    if (v && sv) mergeSound(v, sv);
  }
  // console.log(variant);
  return {
    gameData: {
      ...v,
      title,
      description,
      translatedBy,
      locale: locale ?? i18nGameData.defaultLocale,
    } as unknown as GameControllerI18n<G>,
    translateGameData,
    ...rest,
  };
};

export const combinePairingGames = (
  games: GameControllerInfo<GameType>[],
  enablePractice: boolean,
): GameControllerInfo<GameType>[] => {
  return games;

  // const { textPairingGames, imagePairingGames } = games.reduce<{
  //   textPairingGames: GameControllerInfo<GameType.Pairing>[];
  //   imagePairingGames: GameControllerInfo<GameType.Pairing>[];
  // }>(
  //   (acc, game) => {
  //     if (isGameType(game, GameType.Pairing)) {
  //       const type = game.gameData.pairs[0]?.answer?.type;
  //       if (type === GameChoiceType.Text) {
  //         acc.textPairingGames.push(game);
  //       } else if (
  //         type &&
  //         [GameChoiceType.Image, GameChoiceType.Resource].includes(type)
  //       ) {
  //         acc.imagePairingGames.push(game);
  //       }
  //     }
  //     return acc;
  //   },
  //   { textPairingGames: [], imagePairingGames: [] },
  // );

  // return games.reduce<GameControllerInfo<keyof GameTypes>[]>((acc, game) => {
  //   if (!isGameType(game, GameType.Pairing)) {
  //     acc.push(game);
  //     return acc;
  //   }

  //   if (game.fake) {
  //     return acc;
  //   }

  //   let pool: GameControllerInfo<GameType.Pairing>[] = [];
  //   const type = game.gameData.pairs[0]?.answer?.type;
  //   if (type === GameChoiceType.Text) {
  //     pool = textPairingGames;
  //   } else if (
  //     type &&
  //     [GameChoiceType.Image, GameChoiceType.Resource].includes(type)
  //   ) {
  //     pool = imagePairingGames;
  //   }

  //   const indexInPool = pool.findIndex((g) => g === game);
  //   const gameClone = cloneDeep(game);

  //   const priorGames = pool.slice(0, indexInPool);
  //   gameClone.gameData.pairs = gameClone.gameData.pairs.concat(
  //     priorGames.flatMap((g) => g.gameData.pairs.map((pair) => ({ ...pair }))),
  //   );
  //   gameClone.dependencies = mapValues(gameClone.dependencies, (value, key) =>
  //     value.concat(
  //       priorGames.flatMap(
  //         (g) => g.dependencies[key as keyof typeof gameClone.dependencies],
  //       ),
  //     ),
  //   );

  //   if (gameClone.gameData.pairs[0]) {
  //     if (enablePractice) {
  //       gameClone.gameData.pairs[0].repeat = 1;
  //       gameClone.gameData.pairs[0].enablePractice = true;
  //       for (
  //         let i = 1;
  //         i < Math.min(gameClone.gameData.pairs.length + 2, 7);
  //         ++i
  //       ) {
  //         const pair =
  //           gameClone.gameData.pairs[
  //             Math.floor(Math.random() * gameClone.gameData.pairs.length)
  //           ];
  //         if (pair) pair.repeat = (pair.repeat ?? 0) + 1;
  //       }
  //     } else {
  //       gameClone.gameData.pairs[0].repeat = 1;
  //       gameClone.gameData.pairs[0].enablePractice = false;
  //     }
  //   }

  //   // TODO: fake answer from default
  //   const subsequentGames = pool.slice(indexInPool + 1, 4);
  //   gameClone.gameData.pairs = gameClone.gameData.pairs.concat(
  //     subsequentGames.flatMap((g) =>
  //       g.gameData.pairs.map((pair) => ({ ...pair })),
  //     ),
  //   );
  //   gameClone.dependencies = mapValues(gameClone.dependencies, (value, key) =>
  //     value.concat(
  //       subsequentGames.flatMap(
  //         (g) => g.dependencies[key as keyof typeof gameClone.dependencies],
  //       ),
  //     ),
  //   );
  //   acc.push(gameClone);

  //   return acc;
  // }, []);
};

export const resolveAutoTimeLimit = (
  game?: GameControllerInfo<keyof GameTypes>,
):
  | (Omit<GameControllerInfo<keyof GameTypes>, 'timeLimit'> & {
      timeLimit: number;
    })
  | undefined => {
  if (game === undefined) {
    return undefined;
  }

  if (game.timeLimit === 'auto') {
    let timeLimit;

    // original it take sound file duration into account
    // now, for simplicity, use text length to replace it
    const getInstructionTimeLimit = (instruction?: {
      text?: string;
      images?: unknown[];
    }): number =>
      instruction
        ? getCharacterCount(instruction.text ?? '') * 2 +
          (instruction.images ?? []).length
        : 0;

    if (isGameType(game, GameType.TextOrdering)) {
      timeLimit =
        getInstructionTimeLimit(game.gameData.instruction) +
        game.gameData.answer.words.reduce(
          (acc, { word, units }) =>
            acc +
            getCharacterCount(word) +
            units.reduce(
              (a, { type, key }) =>
                // originally it take non-auto distractor into account
                a +
                (type === TextOrderingUnitType.Blank
                  ? 1 + getCharacterCount(key)
                  : 0),
              0,
            ),
          0,
        );
    } else if (isGameType(game, GameType.FingerWriting)) {
      timeLimit = Infinity;
      // } else if (isGameType(game, GameType.MultipleChoice)) {
      //   timeLimit =
      //     getInstructionTimeLimit(game.gameData.instruction) +
      //     (game.gameData.distractors.length + 1) * 10;
      // } else if (isGameType(game, GameType.Pairing)) {
      //   timeLimit = game.gameData.pairs.reduce(
      //     (acc, { hint, answer, repeat }) =>
      //       acc +
      //       (getInstructionTimeLimit(hint) +
      //         (answer.type === GameChoiceType.Text
      //           ? getCharacterCount(answer.text)
      //           : 5)) *
      //         (repeat ?? 0),
      //     game.gameData.pairs[0]?.enablePractice ? 10 : 0,
      //   );

      //   // } else if (isGameType(game, GameType.Speaking)) {
      //   //   timeLimit =
      //   //     getInstructionTimeLimit(game.gameData?.instruction) +
      //   //     getCharacterCount(game.gameData?.answer?.text ?? '') * 10;
      // } else if (isGameType(game, GameType.Ordering)) {
      //   timeLimit =
      //     getInstructionTimeLimit(game.gameData.instruction) +
      //     game.gameData.answer.units.length * 5;
      // } else if (isGameType(game, GameType.Matching)) {
      //   timeLimit =
      //     getInstructionTimeLimit(game.gameData.instruction) +
      //     game.gameData.pairs.reduce(
      //       (acc, { first, second }) =>
      //         acc +
      //         (first.text ? Math.max(3, getCharacterCount(first.text)) : 0) +
      //         (first.image ? 5 : 0) +
      //         (second.text ? Math.max(3, getCharacterCount(second.text)) : 0) +
      //         (second.image ? 5 : 0),
      //       0,
      //     );
      // } else if (
      //   isGameType(game, GameType.Conversation) ||
      //   isGameType(game, GameType.ManuallyEvaluatedConversation)
      // ) {
      //   timeLimit = Infinity;
    } else {
      timeLimit = 60;
    }

    return { ...game, timeLimit: INFINITY_TIME ? Infinity : timeLimit * 1000 };
  }

  return { ...game, timeLimit: game.timeLimit };
};

// export const retrieveFiles = (
//   games: GameInfo<GameType>[],
//   scopeParams: ScopeType,
// ): FileData[] => {
//   return games.flatMap((g) => [
//     ...g.dependencies.images.map((fileId) => ({
//       fileType: FileType.Image,
//       fileId,
//       scope: getGameScope({
//         ...scopeParams,
//         gameCollection: g.gameCollectionId,
//         game: g.gameId,
//       }),
//       version: ImageVersion.Large,
//     })),
//     ...g.dependencies.resourceImages.map((fileId) => ({
//       fileType: FileType.ResourceImage,
//       fileId,
//       scope: getGameScope({
//         ...scopeParams,
//         gameCollection: g.gameCollectionId,
//         game: g.gameId,
//       }),
//       version: ImageVersion.Large,
//     })),
//     ...g.dependencies.audios.map((fileId) => ({
//       fileType: FileType.Audio,
//       fileId,
//       scope: getGameScope({
//         ...scopeParams,
//         gameCollection: g.gameCollectionId,
//         game: g.gameId,
//       }),
//     })),
//     ...g.dependencies.videos.map((fileId) => ({
//       fileType: FileType.Video,
//       fileId,
//       scope: getGameScope({
//         ...scopeParams,
//         gameCollection: g.gameCollectionId,
//         game: g.gameId,
//       }),
//     })),
//     ...g.dependencies.strokes.map((fileId) => ({
//       fileType: FileType.Stroke,
//       fileId,
//       scope: getGameScope({
//         ...scopeParams,
//         gameCollection: g.gameCollectionId,
//         game: g.gameId,
//       }),
//     })),
//   ]);
// };

export const computeScore = (
  scores: Record<string, number[]> | number,
  length: number,
): number => {
  const score =
    typeof scores === 'number'
      ? scores
      : Object.values(scores)
          .flat()
          .reduce((acc, cur) => acc + cur, 0) / length;
  // final score: if 0.000001~100 => 1~100. if 0 => 0
  return score > 0 && score < 1 ? 1 : score;
};

export const getRevisionScheduleGrade = (score: number): number => {
  const star = getStarsByScore(score);
  switch (star) {
    case 5:
      return 3;
    case 4:
    case 3:
      return 2;
    case 2:
    case 1:
    case 0:
    default:
      return 1;
  }
};

// export const computeRevisionSchedule = ({
//   classroomId,
//   gameSetId,
//   gameId,
//   gameCollectionId,
//   userId,
//   revisionSchedule,
//   newRecord,
// }: {
//   classroomId: string;
//   gameSetId: string;
//   gameId: string;
//   gameCollectionId: string;
//   userId: UserId;
//   revisionSchedule: RevisionSchedule | null;
//   newRecord: RequiredPick<
//     GameRecordJson,
//     | 'playedBy'
//     | 'gameHash'
//     | 'startedAt'
//     | 'endedAt'
//     | 'score'
//     | 'durationInMs'
//     | 'fee'
//     | 'reward'
//   >;
// }): RevisionSchedule => {
//   const { getAlbum, getMembership } = useSpaceStore.getState();

//   const rs = revisionSchedule?.getRecords() ?? [];
//   let newRevisionSchedule: RevisionScheduleJson<Date | number>;
//   if (revisionSchedule === null) {
//     // first time
//     newRevisionSchedule = {
//       gameId: gameId,
//       userId: newRecord.playedBy,
//       classroomId: classroomId,
//       gameSetId: gameSetId,
//       gameCollectionId: gameCollectionId,
//       gameHash: newRecord.gameHash,
//       createdAt: Date.now(),
//       lastModifiedAt: Date.now(),
//       records: [
//         {
//           startedAt: newRecord.startedAt,
//           endedAt: newRecord.endedAt,
//           score: newRecord.score,
//           durationInMs: newRecord.durationInMs,
//           fee: newRecord.fee,
//           reward: newRecord.reward,
//           nextPhase: Math.max(getRevisionScheduleGrade(newRecord.score), 1),
//         },
//       ],
//       memoryIndex: [newRecord.score],
//     };
//   } else {
//     const partitionId = getAlbum(gameSetId)?.partitionId;
//     const latestRecord = rs[rs.length - 1];
//     const latestScheduledAt = latestRecord?.getScheduledAt(
//       getMembership(classroomId, userId)?.revisionSettings?.find(
//         (item) => item.partitionId === partitionId,
//       )?.completedAt,
//       newRecord.endedAt,
//     );
//     const replaceRecord =
//       (latestScheduledAt?.getTime() ?? 0) > newRecord.endedAt; // replace old record or add new record
//     const _rs = rs.slice(0, rs.length - (replaceRecord ? 1 : 0));
//     let newPhase = 0;
//     if (!inRange(_rs[_rs.length - 1]?.nextPhase ?? 0, 1, 13)) {
//       // previous record is hidden
//       newPhase = Math.max(getRevisionScheduleGrade(newRecord.score), 1);
//     } else if (
//       !(
//         newRecord.score === 0 &&
//         _rs[_rs.length - 1]?.score === 0 &&
//         _rs[_rs.length - 2]?.score === 0
//       )
//     ) {
//       // not getting 3 consecutive 0 scores
//       const oldStars = getStarsByScore(_rs[_rs.length - 1]?.score);
//       const newStars = getStarsByScore(newRecord.score);
//       if (newRecord.score >= 100 || newStars > oldStars) {
//         newPhase = (_rs[_rs.length - 1]?.nextPhase ?? 0) + 2;
//       } else if (newStars === oldStars) {
//         newPhase = (_rs[_rs.length - 1]?.nextPhase ?? 0) + 1;
//       } else {
//         newPhase = Math.max(getRevisionScheduleGrade(newRecord.score), 1);
//       }
//     }
//     if (newPhase > 12) {
//       // convert to 0 for checking 'hidden'
//       newPhase = 0;
//     }

//     // get corresponding memoryIndex by current phase
//     const mI: number =
//       revisionPhaseToMemoryIndex(_rs[_rs.length - 1]?.nextPhase ?? newPhase) ??
//       0;
//     const memoryIndex = Array.from(
//       { length: Math.max(mI + 1, revisionSchedule.memoryIndex.length) },
//       (_, i) => {
//         if (i === mI) {
//           // set current score to current phase
//           return newRecord.score;
//         }
//         return revisionSchedule?.memoryIndex[i] ?? newRecord.score;
//       },
//     );

//     const r = {
//       startedAt: newRecord.startedAt,
//       endedAt: newRecord.endedAt,
//       score: newRecord.score,
//       durationInMs: newRecord.durationInMs,
//       fee: newRecord.fee,
//       reward: newRecord.reward,
//       nextPhase: newPhase,
//     };
//     newRevisionSchedule = {
//       ...revisionSchedule,
//       gameHash: newRecord.gameHash,
//       records: [..._rs, r],
//       memoryIndex,
//     };
//   }
//   return new RevisionSchedule(newRevisionSchedule);
// };

type Opponents = {
  profiles: { profile: ProfileJson }[];
  opponents: (GameRecordJson | null)[];
};
type GameDummies = {
  gameId: string;
  opponents: Opponents;
};
type GivenRecord = {
  score: number;
  durationInMs: number;
};
export function generateDummies(
  { opponents }: GameDummies,
  givenRecord?: GivenRecord,
): OpponentsRecords {
  const res = {
    opponents: [] as GameRecord[],
    profiles: opponents.profiles.map(({ profile }) => new Profile(profile)),
  };
  const pushRecord = () => {
    opponents.opponents.forEach((record) => {
      const hasProfile =
        res.profiles.find(
          ({ userId }) => record?.playedBy?.endsWith(userId),
        ) !== undefined;
      if (record && hasProfile) {
        // avoid add null or no profile member
        const _record: GameRecordJson = {
          ...record,
          ...givenRecord, // overridden score/durationInMs
        };
        res.opponents.push(new GameRecord(_record));
      }
    });
  };
  pushRecord();
  return {
    opponents: shuffle(res.opponents),
    profiles: res.profiles,
  };
}

export const sortDummiesRecords = <
  R extends { score?: number; durationInMs?: number },
>(
  dummies: Pick<OpponentsRecords, 'opponents'>,
  record: R,
): R[] => {
  return orderBy<R>(
    [...dummies.opponents, record] as R[],
    ['score', 'durationInMs'],
    ['desc', 'asc'],
  );
};
